import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import '../../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../../icons/icon/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import '../../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../../spacing/spacing/index.esm.js';
import '../../../spacing/spacing-hr/index.esm.js';
import { EGDSDateDisplay } from '../date-display/index.esm.js';
import styles from '../../../styles/uitk-egds-date-selector.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
import { useIdCompatibility } from '../../../utils/use-id-compatibility/index.esm.js';
const getClassNameList = classNames.bind(styles);
const dateSelectorPlaybackClassName = 'uitk-date-selector-playback';
const arrowIconClassName = `${dateSelectorPlaybackClassName}-icon`;
const EGDSDateSelectorPlayback = props => {
  const {
    locale,
    startLabel,
    endLabel,
    startDate,
    endDate,
    dateFormatOptions,
    updateSelectionChangeMode = () => {},
    selectionChangeMode,
    isMultiPlaybackDateDisplay,
    isFullSizePlaybackDateDisplay
  } = props;
  const l10n = useLocalization();
  const isStartActive = selectionChangeMode === 'start';
  const isEndActive = !isStartActive;
  const defaultStartLabel = l10n.formatText('dateSelector.startDate.label');
  const defaultEndLabel = l10n.formatText('dateSelector.endDate.label');
  const uId = useIdCompatibility();
  const handleClickStartDateDisplay = () => {
    updateSelectionChangeMode('start');
  };
  const handleClickEndDateDisplay = () => {
    // If there is an end date, allow user to select end date-display
    // Otherwise do nothing
    if (endDate) {
      updateSelectionChangeMode('end');
    }
  };
  return jsxs(EGDSLayoutFlex, {
    "data-testid": "date-selector-playback",
    direction: "row",
    alignItems: "center",
    className: getClassNameList(dateSelectorPlaybackClassName),
    children: [jsx(EGDSLayoutFlexItem, {
      children: jsx(EGDSDateDisplay, {
        id: `${uId}-date-display1`,
        locale: locale,
        label: startLabel || defaultStartLabel,
        date: startDate || null,
        dateFormatOptions: dateFormatOptions,
        isActive: isStartActive,
        isFullSize: isFullSizePlaybackDateDisplay,
        onDateDisplayClick: handleClickStartDateDisplay
      })
    }), isMultiPlaybackDateDisplay && jsxs(Fragment, {
      children: [jsx(EGDSLayoutFlexItem, {
        children: jsx(EGDSSpacing, {
          margin: {
            inline: 'three'
          },
          children: jsx(EGDSIcon, {
            name: "arrow_forward",
            size: EGDSIconSize.SMALL,
            className: getClassNameList(arrowIconClassName)
          })
        })
      }), jsx(EGDSLayoutFlexItem, {
        children: jsx(EGDSDateDisplay, {
          id: `${uId}-date-display2`,
          locale: locale,
          label: endLabel || defaultEndLabel,
          date: endDate || null,
          dateFormatOptions: dateFormatOptions,
          isActive: isEndActive,
          isFullSize: isFullSizePlaybackDateDisplay,
          onDateDisplayClick: handleClickEndDateDisplay
        })
      })]
    })]
  });
};
export { EGDSDateSelectorPlayback };